import type { FaireProductEntity } from "../../entity_types/product";

export const p_jp93mquugc: FaireProductEntity = {
  token: "p_jp93mquugc",
  type: "product",
  name: "Hold me tight Earrings, Knotted Rope Stud with Chubby Pearl",
  brandToken: "b_493edh35w5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c46e2e396623bd9a7d762a2bff3b7b98919e094396d4a00c0f7a069838ce4570.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26a215aac80638d46fadae68466420c9308d8b2988f69e54d2a88a06effff657.jpeg",
    "https://cdn.faire.com/fastly/fd6e69569cac709a8f12565c08d81e2121b5d27753a4f5d3690b2107e666e7f0.jpeg",
    "https://cdn.faire.com/fastly/0ee21571580516c9eb57bd8fd800035d045cbb1dd528b48bbe8cf97f49bc0fb8.jpeg",
    "https://cdn.faire.com/fastly/d41b44a826b2f233e3ee98db2978a94b5b66c33db19ac4e346bb3e4cc71fa8e5.jpeg",
    "https://cdn.faire.com/fastly/eff8e2442b14ee65943683cdbab32e80c854a55190b7755ec0ad639386e62d5c.jpeg",
  ],
  priceDollars: 15,
  description:
    "Discover the charm of our unique Hold Me Tight Earrings. These earrings feature a golden knotted rope stud with an extra-large back ball closure. You can wear them with the knot heads or reverse them for a different look. A distinctive and versatile addition to your collection.\n\nPlease take note that our plated jewelry is crafted with beautiful gold plating. The ring component of the jewelry is made with a nickel-free alloy to provide added durability. We kindly advise individuals with skin sensitivity to specific metals to check before purchasing.\n\n- Nickel-free plated brass\n- Ball: 16mm\n- Knot: 30mm*14mm",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:55.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
